import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import { memo } from 'react'
import NewProgressNoteAction from './NewProgressNoteAction'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import {
  canProviderAccessNote,
  canSharedServiceProviderOpenNote,
  getNoteStatuses,
  getProgressNoteIcon,
  shouldHidePrivateNote,
} from '../../../../../utils/sharedChartFunctions'
import {
  noteAccessErrorMessage,
  privateNoteErrorMessage,
  sspOpenNoteErrorMessage,
} from '../../../ProgressNote/progressNoteConstants'
import { setPanelDetails, setTabIndexes } from '../../../../../redux/sidePanel/sidePanelSlice'
import { SIDE_PANEL_TAB_COL_INDEXES } from '../../../sharedConstants'
import { getIsAi } from '../../../../../utils/sharedFeaturesFunctions'
import { refreshEncounter } from '../../../../../redux/sidePanel/sidePanelThunk'
import { VISIT_STATUS } from '../../../../../utils/statusConstants'

const ProgressNoteIconBtn = ({ status, visit, startVisit, setIsAddendumOpen, isHistory }) => {
  const dispatch = useDispatch()
  const provider = useSelector((state) => state?.user?.provider)
  const userId = useSelector((state) => state?.user?.user?._id)

  const noteIcon = getProgressNoteIcon(visit, { fontSize: '0.9em', isHistory, userId })

  // TODO update nav clicks
  const isHiddenNote = (e) => {
    if (shouldHidePrivateNote(visit?.chart, userId)) {
      toast.info(privateNoteErrorMessage)
      e?.preventDefault()
    }
  }

  const isWrongProvider = (e) => {
    if (!canProviderAccessNote(visit, provider)) {
      toast.error(noteAccessErrorMessage)
      e?.preventDefault()
    }
  }

  const isSidePanel = (e) => {
    if (getIsAi() && !e.defaultPrevented) {
      e?.preventDefault()
      dispatch(setTabIndexes({ side: SIDE_PANEL_TAB_COL_INDEXES.NOTE }))
      dispatch(
        setPanelDetails({
          visitId: visit?._id,
          isLastEncounter: false,
        }),
      )
      dispatch(refreshEncounter({ encounterId: visit?._id }))
    }
  }

  return (
    <>
      {status === 'new' ? (
        <div
          onClick={() => {
            if (!canProviderAccessNote(visit, provider)) {
              toast.error(noteAccessErrorMessage)
              return
            }
            if (!canSharedServiceProviderOpenNote(visit, provider)) {
              toast.error(sspOpenNoteErrorMessage)
              return
            }
            startVisit()
          }}
          className="note-icons no-note"
        >
          {noteIcon}
        </div>
      ) : status === 'pending_review' ? (
        <Link
          to={`/progressnote/${visit?.visitId}`}
          className="note-icons pending-review-note"
          onClick={(e) => {
            // if either of these checks are true
            // they stop the link from firing
            isHiddenNote(e)
            isWrongProvider(e)
            isSidePanel(e)
          }}
        >
          {noteIcon}
        </Link>
      ) : status === 'edit' ? (
        <Link
          to={`/progressnote/${visit?.visitId}`}
          className="note-icons draft-note"
          onClick={(e) => {
            // if either of these checks are true
            // the stop the link from firing
            isHiddenNote(e)
            isWrongProvider(e)
            isSidePanel(e)
          }}
        >
          {noteIcon}
        </Link>
      ) : status === 'complete' ? (
        <div
          onClick={() => {
            if (shouldHidePrivateNote(visit?.chart, userId)) {
              toast.info(privateNoteErrorMessage)
            } else {
              if (getIsAi()) {
                dispatch(setTabIndexes({ side: SIDE_PANEL_TAB_COL_INDEXES.NOTE }))
                dispatch(
                  setPanelDetails({
                    visitId: visit?._id,
                    isLastEncounter: visit?.status === VISIT_STATUS.last,
                  }),
                )
                dispatch(refreshEncounter({ encounterId: visit?._id }))

                return
              }

              setIsAddendumOpen(true)
            }
          }}
        >
          {noteIcon}
        </div>
      ) : null}
    </>
  )
}

const ProgressNoteIconAction = ({
  item,
  isHistory,
  setIsAddendumOpen = () => {},
  disabled = false,
}) => {
  const [startModal, setStartModal] = useState(false)

  const { btnStatus, sentStatus } = getNoteStatuses(item, isHistory)

  return (
    <div style={{ pointerEvents: disabled ? 'none' : '' }}>
      <ProgressNoteIconBtn
        status={btnStatus}
        visit={item}
        startVisit={() => setStartModal(true)}
        setIsAddendumOpen={setIsAddendumOpen}
        isHistory={isHistory}
      />
      {startModal && <NewProgressNoteAction onToggle={setStartModal} visit={item} />}
    </div>
  )
}

export default memo(ProgressNoteIconAction)
